import VideoTheaterModeIcon from '@atlaskit/icon-lab/core/video-theater-mode';
import * as React from 'react';

export function SvgCrop169() {
  return <VideoTheaterModeIcon label="" testId="ads-refreshed-icon" />;
}
